import React, { useState } from "react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import { getBoilerPlateTandCs, updateBoilerPlateTandCs } from "./actions";
import BoilerPlateForm from "./BoilerPlateForm";

const EditBoilerPlateModal = ({
  id,
  dealerId,
  onUpdated,
  reference,
  ...props
}) => {
  let apiParams = {
    dealerId,
    id,
  };
  const [uploadDoc, setUploadDoc] = useState(null);

  const onChangeUpload = (file) => {
    let fileReader = new FileReader();
    fileReader.onload = () => {
      const res = fileReader.result;
      setUploadDoc(res);
    };
    fileReader.readAsDataURL(file);
  };
  return (
    <ModalBuilder
      withForm
      loadAction={getBoilerPlateTandCs}
      loadParams={{ dealerId, id }}
      submitAction={updateBoilerPlateTandCs}
      submitParams={{ dealerId, id, uploadDoc }}
      onSubmitted={onUpdated}
      renderTrigger={(showModal) => (
        <div {...props} onClick={showModal} className="item">
          Edit
        </div>
      )}
      renderModal={(modalProps, formProps) => (
        <Modal.Edit
          {...modalProps}
          header={"Master Agreement Terms: " + reference}
          submitLabel="Update"
        >
          <BoilerPlateForm
            {...formProps}
            onChangeUpload={onChangeUpload}
            editMode={true}
          />
        </Modal.Edit>
      )}
    />
  );
};

export default EditBoilerPlateModal;
